import { render, staticRenderFns } from "./PolicyDialog.vue?vue&type=template&id=a9f87c86"
import script from "./PolicyDialog.vue?vue&type=script&lang=js"
export * from "./PolicyDialog.vue?vue&type=script&lang=js"
import style0 from "./PolicyDialog.vue?vue&type=style&index=0&id=a9f87c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports